<template>
    <div class="departments">
        <div class="type uk-h5">{{ $t("message.departments")}}</div>

        <div class="">
            <ul class="uk-list">
                <li>
                    <button
                        @click="filterDept(null)"
                        :class="['uk-text-heading uk-text-default uk-text-capitalize', { 'uk-link-orange': activeDept === undefined }]"
                        :title="$t('message.all_departments')"
                        type="button"
                    >{{ $t("message.all_departments") }}</button>
                </li>
                <li v-for="item in departments" :key="item.id">
                    <button
                            @click="filterDept(item.id)"
                            :class="['uk-text-heading uk-text-default', { 'uk-link-orange': activeDept === item.id }]"
                            :title="item.name"
                            type="button"
                    >{{item.name}}</button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
      name: "department-filter",
      props: ['departments', 'activeDept', 'activeDeptName'],
      computed: {
      },
      methods: {
        filterDept(id){
          this.$emit('dept-filtered', id)
        },
      }
    }
</script>
